import * as S from './styles';

export const SecureEnvironment: React.VFC = () => {
  return (
    <S.Wrapper>
      <S.Text variant="small">Ambiente seguro</S.Text>
    </S.Wrapper>
  );
};
